export default "__VITE_ASSET__DXxHFxcZ__"